import { Component } from '@theme/component';
(() => {
  if (customElements.get('kt-navigation')) return;
  class KarrytonNavigation extends Component {
    connectedCallback() {
      super.connectedCallback(); this.initialize();
    }
    updatedCallback() {super.updatedCallback();this.close(false);this.initialize();}
    initialize() {
      this.abort?.abort(); this.abort = new AbortController();
      this.trigger=this.querySelector('[data-kt-open]'); this.layer=this.querySelector('[data-kt-layer]'); this.drawer=this.querySelector('.kt-drawer');
      const options={signal:this.abort.signal};
      this.trigger?.addEventListener('click',()=>this.open(),options);
      this.querySelectorAll('[data-kt-close]').forEach(button=>button.addEventListener('click',()=>this.close(),options));
      this.querySelectorAll('[data-kt-disclosure]').forEach(button=>button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));this.querySelector('#'+CSS.escape(button.getAttribute('aria-controls'))).hidden=open;button.querySelector('svg')?.classList.toggle('kt-chevronOpen',!open);},options));
      this.querySelectorAll('.kt-drawer a').forEach(link=>link.addEventListener('click',()=>this.close(),options));
      document.addEventListener('keydown',event=>{
        if(this.layer.hidden)return;
        if(event.key==='Escape'){event.preventDefault();this.close();}
        if(event.key==='Tab'){
          const items=[...this.drawer.querySelectorAll('a[href],button,input')].filter(el=>el.getClientRects().length);
          const first=items[0],last=items[items.length-1];
          if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
          else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
        }
      },options);
      this.media=matchMedia('(min-width:1025px)');this.media.addEventListener('change',()=>{if(this.media.matches)this.close();},options);
    }
    open(){this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.layer.hidden=false;this.trigger.setAttribute('aria-expanded','true');this.drawer.querySelector('button')?.focus();}
    close(restoreFocus=true){if(!this.layer||this.layer.hidden)return;this.layer.hidden=true;document.body.style.overflow=this.previousOverflow||'';this.trigger.setAttribute('aria-expanded','false');if(restoreFocus)this.trigger.focus();}
    disconnectedCallback(){this.close(false);this.abort?.abort();super.disconnectedCallback();}
  }
  customElements.define('kt-navigation',KarrytonNavigation);
})();
